// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__l2F0q","notes":"Notes_notes__269pP"};